export default "__VITE_ASSET__5a33f0bc__"